<template>
  <v-hover :disabled="click_to_open">
    <template #default="hover_slot">
    <div class="standard-overflow-button" :id="element_id">
      <TTooltip :value="tooltip">
        <v-btn
          :class="button_color"
          icon
          :small="small"
          @click="click_to_open?(!disabled?(open = !open):'', $emit('button-clicked')):$emit('button-clicked')"
        >
          <div v-if="value.colors && !icon" :class="`color-badge ${value.colors[0]} ${value.colors[0].includes('lighten') || value.colors[0].includes('darken')? '':'lighten-1'}`"/>
          <TIcon
            v-else-if="icon_new"
            :name="getNewIcon(getIcon())"
          />
          <svg-icon
            v-else-if="isSvgIcon(getIcon())"
            :name="getIcon()"
            :style="` fill: white;padding-top: 3px; padding-right: 3px`"
            :size="23"
          />
          <TIcon
            v-else-if="ticon"
            :name="ticon"
          />
          <TIcon
            v-else
            :name="getNewIcon(getIcon())"
            :color="icon_color"
          />


          <div
            v-if="Object.keys(value)[0] === 'value' && Object.values(value)[0].substring(Object.values(value)[0].length -9) === '_material'"
            class="overflow_button_icon_actual_value orange"
            />
          <div
          v-if="Object.keys(value)[0] === 'value' && Object.values(value)[0].substring(Object.values(value)[0].length -7) === '_labour'"
          class="overflow_button_icon_actual_value blue"
          />
          <div
            v-if="Object.keys(value)[0] === 'value' && Object.values(value)[0].substring(Object.values(value)[0].length -7) === '_actual'"
            class="overflow_button_icon_actual_value green"
            />
        </v-btn>
      </TTooltip>
      <div class="overflow-options" :style="`width: ${calcWidth()};${small?'margin-left: 28px':''}`">
        <transition
          v-for="index_x in options_length"
          :key="index_x-1"
          @before-enter="beforeEnter($event, index_x-1)"
          @after-enter="afterEnter"
          @before-leave="beforeLeave($event, index_x-1, options_length)"
          @leave="leave"
        >
          <div class="options-column" v-if="hover_slot.hover || open">
            <template v-for="index_y in Object.values(options).length">
              <v-btn
                v-if="Object.values(options)[index_y-1][index_x-1]"
                :key="`${index_x-1}x${index_y-1}`"
                :class="isSelected(index_y-1, Object.values(options)[index_y-1][index_x-1])"
                icon
                :small="small"
                :ripple="!Object.values(options)[index_y-1][index_x-1].disabled"
                :style="`${Object.values(options)[index_y-1][index_x-1].disabled ? 'cursor: default;' : 'cursor: pointer;'}`"
                @click="!Object.values(options)[index_y-1][index_x-1].disabled
                  ? $emit('select-option', {setting: Object.keys(options)[index_y-1], value: Object.values(options)[index_y-1][index_x-1].value})
                  : ''
                "
                v-on:click.ctrl="!Object.values(options)[index_y-1][index_x-1].disabled
                  ? $emit('button-clicked-strg', {setting: Object.keys(options)[index_y-1], value: Object.values(options)[index_y-1][index_x-1].value})
                  : ''
                "
              >
              <!-- :disabled="Object.values(options)[index_y-1][index_x-1].disabled" -->
                <TTooltip v-if="Object.values(options)[index_y-1][index_x-1].icon"
                  :value="Object.values(options)[index_y-1][index_x-1].language === false ? false : Object.values(options)[index_y-1][index_x-1].tooltip"
                  :text="Object.values(options)[index_y-1][index_x-1].language === false ? Object.values(options)[index_y-1][index_x-1].tooltip : false"
                >
                  <div
                    :style="`${Object.values(options)[index_y-1][index_x-1].disabled ? 'opacity: 0.33;' : ''}`"
                  >
                    <!-- {{ Object.values(options)[index_y-1][index_x-1].language === false ? false : Object.values(options)[index_y-1][index_x-1].tooltip }} -->
                    <TIcon
                      v-if="Object.values(options)[index_y-1][index_x-1].wp_icon"
                      :name="getNewIcon(Object.values(options)[index_y-1][index_x-1].icon)"
                      medium
                      :color="icon_color ? icon_color : ''"
                    />
                    <TIcon
                      v-else-if="Object.values(options)[index_y-1][index_x-1].ticon"
                      :name="Object.values(options)[index_y-1][index_x-1].ticon"
                      medium
                      :color="icon_color ? icon_color : ''"
                    />
                    <TIcon
                      v-else
                      :name="Object.values(options)[index_y-1][index_x-1].icon"
                      :color="icon_color"
                      :small="small"
                    />
                  </div>
                </TTooltip>
                <TTooltip v-else
                  :value="Object.values(options)[index_y-1][index_x-1].language === false ? false : Object.values(options)[index_y-1][index_x-1].tooltip"
                  :text="Object.values(options)[index_y-1][index_x-1].language === false ? Object.values(options)[index_y-1][index_x-1].tooltip : false"
                >
                  <div :class="`color-badge ${Object.values(options)[index_y-1][index_x-1].value} ${Object.values(options)[index_y-1][index_x-1].value.includes('lighten') || Object.values(options)[index_y-1][index_x-1].value.includes('darken')? '':'lighten-1'}`"/>
                </TTooltip>
                <div
                  v-if="Object.keys(value)[0] === 'value' && Object.values(options)[index_y-1][index_x-1].value.substring(Object.values(options)[index_y-1][index_x-1].value.length -9) === '_material'"
                  class="overflow_button_icon_actual_value orange"
                  />
                <div
                  v-if="Object.keys(value)[0] === 'value' && Object.values(options)[index_y-1][index_x-1].value.substring(Object.values(options)[index_y-1][index_x-1].value.length -7) === '_actual'"
                  class="overflow_button_icon_actual_value green"
                  />
                  <div
                  v-if="Object.keys(value)[0] === 'value' && Object.values(options)[index_y-1][index_x-1].value.substring(Object.values(options)[index_y-1][index_x-1].value.length -7) === '_labour'"
                  class="overflow_button_icon_actual_value blue"
                  />
              </v-btn>
              <div
                v-else
                class="options-placeholder"
                :key="`${index_x-1}x${index_y-1}`"
                />
          </template>
          </div>
        </transition>
      </div>
  </div>
</template>
</v-hover>
</template>
<script>
import {mapGetters} from 'vuex';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue'

export default {
  props: [
    'value',
    'options',
    'multiselect',
    'icon',
    'icon_new',
    'ticon',
    'icon_color',
    'button_color_selected',
    'button_color',
    'colors',
    'icons',
    'small',
    'click_to_open',
    'disabled',
    'tooltip',
    'element_id'
  ],
  data: () => ({
    open: false,
  }),
  components: {
    TIcon,
    TTooltip
  },
  computed: {
    ...mapGetters('View', [
      'isSvgIcon'
    ]),
    ...mapGetters('WorkPackage', [
      'getNewIcon',
      ],
    ),
    options_length: function() {
      let max_length = 0
      for(let prop in this.options) {
        if (this.options[prop].length > max_length) {
          max_length = this.options[prop].length
        }
      }
      return max_length
    }
  },
  methods: {
    calcWidth(){
      // get element by id element_id
      let element = document.getElementById(this.element_id)
      // if element is not found, return 500px
      if (!element) {
        return '500px'
      }

      // get the amount of pixels between the right side of the screen and the right side of the element
      let right = window.innerWidth - element.getBoundingClientRect().right
      // get 80% of "right" in px and return it
      return `${right * 0.8}px`
    },
    isSelected(index_y, option) {
      let color = 'color-2'
      for(let prop in this.options) {
        if (this.multiselect && this.value[prop].find(item => item === option.value)) {
          color = this.button_color_selected?this.button_color_selected:'border-highlight'
        } else if (this.value[prop] === option.value) {
          color = this.button_color_selected?this.button_color_selected:'border-highlight'
        }
      }
      return color
    },
    getIcon() {
      if (this.icon) {
        return this.icon
      } else if (this.multiselect) {
        return Object.values(this.options)[0].find(option => option.value === Object.values(this.value)[0][0]).icon
      } else {
        if (this.value.value) {
          for (var i = 0; i < Object.values(this.options).length; i++) {
            for (var j = 0; j < Object.values(this.options)[i].length; j++) {
              if (Object.values(this.options)[i][j].value == this.value.value) {
                return Object.values(this.options)[i][j].icon;
              }
            }
          }
        } else {
          return Object.values(this.options)[0].find(
            option => option.value === Object.values(this.value)[0]
          ).icon
        }
      }
    },
    beforeEnter(el, index) {
      el.style.opacity = 0
      el.style.transition = `all 50ms ease-in-out ${index * 15}ms`
      // el.style['transition-delay'] = `${index * 1000}ms`
    },
    afterEnter(el) {
      el.style.opacity = 1
    },
    beforeLeave(el, index, max_index) {
      el.style.transition = `all 100ms ease-in-out ${(max_index - index) * 15}ms`
    },
    leave(el) {
      el.style.opacity = 0
    },
    closeFilter(){
      this.open = false;
    }
  }
}
</script>
<style>
  .standard-overflow-button {
    display: flex;
    /* height: 34px; */
  }
  .options-column {
    display: flex;
    flex-direction: column;
  }
  .border-highlight {
    border:2px solid;
    border-color: var(--v-primary-base);
    background-color: var(--v-color-3-base);
  }
  .overflow-options {
    position: absolute;
    display: flex;
    margin-left: 36px;
    /* width: 90vw; */
    flex-wrap: wrap;
  }
  .color-badge {
    height: 20px;
    width: 20px;
    border-radius: 10px;
  }
  .overflow_button_icon_actual_value {
    position: absolute;
    height: 5px;
    width: 5px;
    right: 5px;
    top: 0px;
    border-radius: 5px;
    z-index: 4;
  }
  .options-placeholder {
    height: 36px;
    width: 36px;
  }
</style>
